
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// import prefixAll from 'inline-style-prefixer/static';

import { getUnit, convertSizeToCssValue,convert } from './SplitPane';

function PaneStyle({ animate,split, initialSize, size, isClose, minSize, maxSize, resizersSize,left=true }) {
  const value = size || initialSize;
  const vertical = split === 'vertical';
  const styleProp = {
    minSize: vertical ? 'minWidth' : 'minHeight',
    maxSize: vertical ? 'maxWidth' : 'maxHeight',
    size: vertical ? 'width' : 'height'
  };  
  let style = {
    display: 'flex',
    outline: 'none',
    // position: 'relative',
    // transition: 'all 0.4s ease',
    overflow:'hidden',
    // zIndex:3,
    // justifyContent: "center"
    
  };  
  
  style[styleProp.minSize] = convertSizeToCssValue(minSize, resizersSize);
  // style[styleProp.maxSize] = convertSizeToCssValue(maxSize, resizersSize);

  switch(getUnit(value)) {
    case 'ratio':
      style.flex = value;      
      if(isClose &&left)style["marginLeft"]=`-${value/100}px`;      
      if(isClose &&!left)style["marginRight"]=`-${value/100}px`;      
      break;
    case '%':
    case 'px':
      style.flexGrow = 0;
      const vpx = convertSizeToCssValue(value, resizersSize);
      style[styleProp.size] = vpx;      
      if(isClose&&left)style["marginLeft"]=`-${convert(vpx)+7}px`;
      if(isClose&&!left)style["marginRight"]=`-${convert(vpx)+7}px`;
      break;
  }

  return style;
}


class Pane extends PureComponent {
  setRef = element => {
    this.props.innerRef(this.props.index, element);
  };

  render() {
    const { children, className } = this.props;
    const other={};
    const prefixedStyle = {...other,...PaneStyle(this.props),...this.props.style};
   
    return (
      <div
        className={className}
        style={prefixedStyle}
        ref={this.setRef}
      >
        {children}
      </div>
    );
  }
}

Pane.propTypes = {
  children: PropTypes.node,
  innerRef: PropTypes.func,
  index: PropTypes.number,
  className: PropTypes.string,
  initialSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  minSize: PropTypes.string,
  maxSize: PropTypes.string,
};

Pane.defaultProps = {
  initialSize: '1',
  split: 'vertical',
  minSize: '0',
  maxSize: '100%',
};

export default Pane;